{
  "table": {
    "object": "Object",
    "type": "Type",
    "message": "Message",
    "state": "State",
    "actions": "Actions",
    "createdAt": "Created",
    "client": "Client",
    "userFirstName": "User First Name",
    "userLastName": "User Last Name",
    "date": "Date",
    "amount": "Amount",
    "accountType": "Account Type",
    "ticker": "Ticker",
    "currency": "Currency",
    "price": "Price",
    "quantity": "Quantity",
    "organization": "Organization",
    "processDate": "Process Date",
    "objectType": "Object Type",
    "effectiveDate": "Effective Date",
    "settleDate": "Settle Date",
    "custodianAccountNumber": "Custodian Account Number",
    "clientName": "Client Name",
    "transaction": "Transaction",
    "subTransaction": "SubTransaction",
    "cusip": "CUSIP",
    "transactionDesc": "Transaction Description",
    "transactionType": "Transaction Type",
    "commission": "Commission",
    "accruedInterest": "Accrued Interest",
    "securityType": "Security Type",
    "custodian": "Custodian",
    "account": "Account",
    "flags": "Flags",
    "systemUpdated": "System Updated",
    "externalUpdated": "External Updated"
  },
  "state": "State",
  "exportProgressTitleFlags": "Exporting flags",
  "exportProgressTitleActivities": "Exporting activities",
  "transactionType": "Transaction Type",
  "symbol": "Symbol",
  "custodianAccountNumber": "Custodian Account Number",
  "type": "Type",
  "any": "Any",
  "perPage": "Items per page",
  "goTo": "Go to",
  "tabs": {
    "flags": "Flags",
    "activities": "Activities",
    "jobs": "Jobs"
  },
  "flagsMovedModal": {
    "title": "Flags has moved",
    "body": "Flags now lives in its own dashboard with new filters, summaries and a detail view. You will be redirected there now.",
    "confirm": "Go to Flags"
  },
  "activitiesMovedModal": {
    "title": "Activities has moved",
    "body": "Activities now lives in its own dashboard with metrics and a redesigned worklist. You will be redirected there now.",
    "confirm": "Go to Activities"
  },
  "activitiesV3": {
    "pageTitle": "Activities",
    "pageSubtitle": "Monitor custodian activity reconciliation metrics and backlog.",
    "tablePlaceholder": "Activity worklist coming soon",
    "chartSlot": {
      "placeholder": "Backlog aging chart coming soon"
    },
    "metrics": {
      "error": "Unable to load activity metrics.",
      "occurringToday": {
        "title": "Occurring Today",
        "hint": "Activities occurring today (UTC)"
      },
      "created": {
        "title": "Created",
        "hint": "Pending backlog (all time)"
      },
      "reconciledToday": {
        "title": "Reconciled Today",
        "hint": "Reconciled today (UTC)"
      },
      "agingPending": {
        "title": "Aging Pending",
        "hint": "Pending 3+ days (UTC)"
      }
    },
    "filters": {
      "state": "State",
      "stateCreated": "Created",
      "stateReconciledToday": "Reconciled (today)",
      "type": "Type",
      "aging": "Aging",
      "any": "Any",
      "agingOneDay": "1+ days",
      "agingThreeDays": "3+ days",
      "agingSevenDays": "7+ days",
      "search": "Search",
      "searchPlaceholder": "Client, account #, or ticker",
      "clearFilters": "Clear filters",
      "expandAll": "Expand all",
      "collapseAll": "Collapse all"
    },
    "table": {
      "client": "Client",
      "organization": "Organization",
      "date": "Date",
      "type": "Type",
      "custodianAcct": "Custodian acct",
      "amount": "Amount",
      "acctType": "Acct type",
      "ticker": "Ticker",
      "state": "State",
      "aging": "Aging",
      "reconciledVia": "Reconciled via",
      "empty": "No activities match the current filters.",
      "detailPlaceholder": "Activity detail coming soon"
    },
    "bulk": {
      "selectedCount": "{{count}} selected",
      "selectAllOnPage": "Select all on page",
      "clearSelection": "Clear selection",
      "retry": "Bulk Retry"
    }
  },
  "flagState": {
    "FLAGGED": "Active",
    "FIXED": "Done",
    "TRIVIAL": "Trivial",
    "ALL_FIXED": "Mark selected as Done",
    "ALL_RECONCILE": "Reconcile all",
    "ALL_FORCE_RECONCILE": "Force Reconcile all"
  },
  "activityState": {
    "CREATED": "Created",
    "RECONCILED": "Reconciled",
    "RECONCILE": "Reconcile",
    "FORCE_RECONCILE": "Force Reconcile"
  },
  "jobEventType": {
    "RECONCILIATION": "RECONCILIATION"
  },
  "jobState": {
    "ANY": "ANY",
    "INITIATED": "INITIATED",
    "COMPLETED": "COMPLETED",
    "FAILED": "FAILED"
  },
  "eventTable": {
    "eventType": "Event Type",
    "jobName": "Job Name",
    "ranAt": "Ran At",
    "updatedAt": "Updated",
    "state": "State",
    "organization": "Organization",
    "action": "Action"
  },
  "jobDetails": {
    "title": "Additional details for {{jobName}} ran on {{ranAt}}"
  },
  "runReconciliation": {
    "title": "Run Reconciliation",
    "reconcileActivities": "Recon Activities",
    "updateCashAndHoldings": "Update Cash and Holdings",
    "reconCashAndHoldings": "Recon Cash and Holdings",
    "publishSnapshots": "Publish Snapshots",
    "runReconcileToastMessage": "Reconcile requested"
  },
  "reconFlags": {
    "title": "Reconciliation",
    "summaryTitle": "Summary dashboard",
    "spotlight": {
      "negativeCash": {
        "title": "Negative Cash"
      },
      "negativeHolding": {
        "title": "Negative Holding"
      },
      "holdingsMismatch": {
        "title": "Holdings Mismatch"
      },
      "moneyAvailableMismatch": {
        "title": "Money Avail. Mismatch"
      }
    },
    "totalFlags": "Total flags",
    "totalFlagsHint": "Active in organization",
    "unresolvedThreePlus": "Unresolved for 3+ days",
    "unresolvedThreePlusHint": "Active, first seen more than 3 days ago",
    "severity": {
      "all": "All",
      "critical": "Critical",
      "high": "High",
      "medium": "Medium",
      "low": "Low"
    },
    "severityLabel": {
      "CRITICAL": "Critical",
      "HIGH": "High",
      "MEDIUM": "Medium",
      "LOW": "Low",
      "UNKNOWN": "Unknown"
    },
    "filters": {
      "flagType": "Flag Type",
      "category": "Category",
      "priority": "Priority",
      "aging": "Aging",
      "clearFilters": "Clear filters",
      "any": "Any",
      "agingOneDay": "1+ days",
      "agingThreeDays": "3+ days",
      "agingSevenDays": "7+ days"
    },
    "categories": {
      "snapshot": "Snapshot",
      "warning": "Warning",
      "cashHoldings": "Cash & Holdings",
      "activity": "Activity",
      "transfer": "Transfer",
      "account": "Account",
      "product": "Product"
    },
    "flagTypes": {
      "NEGATIVE_CASH": "Negative cash",
      "NEGATIVE_HOLDING": "Negative holding",
      "DIFFERENT_HOLDINGS_V2": "Holdings mismatch",
      "MONEY_AVAILABLE_VALUE_INCORRECT_V2": "Money avail. mismatch"
    },
    "flagState": {
      "FLAGGED": "Active",
      "FIXED": "Resolved",
      "TRIVIAL": "Dismissed"
    },
    "searchPlaceholder": "Search by client name",
    "searchHelp": "Select a client to show flags for their accounts (up to {{max}} account IDs).",
    "searchHelpAria": "About client search",
    "searchError": "Client search failed. Please try again.",
    "selection": {
      "count": "{{count}} exceptions selected",
      "selectAllOnPage": "Select all on this page",
      "clear": "Clear Selection",
      "dismiss": "Dismiss",
      "dismissConfirmTitle": "Dismiss selected flags?",
      "dismissConfirmBody": "This will mark the selected flag(s) as dismissed. This operation cannot be undone.",
      "dismissConfirmAction": "Dismiss"
    },
    "table": {
      "account": "Account",
      "firstSeen": "First seen"
    },
    "agingDays_one": "{{count}} day",
    "agingDays_other": "{{count}} days",
    "agingHelp": "Days since this issue was <bold>first observed</bold> (First Seen). The flag may refresh daily when reconciliation re-emits the same issue; that does <bold>not</bold> reset aging. Resolve or dismiss when fixed.",
    "agingHelpAria": "About the aging column",
    "drawer": {
      "close": "Close",
      "title": "Flag detail",
      "fallbackTitle": "Flag details",
      "detailsHeading": "Details",
      "summary": {
        "type": "Type:",
        "account": "Account:",
        "date": "Date:",
        "firstSeen": "First seen:"
      },
      "followUpTask": "Create follow-up task",
      "resolve": "Resolve",
      "resolveSuccess": "Flag resolved",
      "resolveError": "Could not resolve this flag",
      "dismissSuccess": "Flag dismissed",
      "dismissError": "Could not dismiss this flag",
      "tabs": {
        "overview": "Overview",
        "notes": "Notes",
        "rawJson": "Raw JSON"
      },
      "sections": {
        "issueSummary": "Issue summary",
        "flagSummary": "Flag summary",
        "account": "Account",
        "activity": "Activity & custodian transfer",
        "systemIdentifiers": "System identifiers",
        "additional": "Additional details"
      },
      "fields": {
        "flagType": "Flag Type",
        "objectType": "Object Type",
        "priority": "Priority",
        "created": "Created",
        "firstSeen": "First seen",
        "state": "State",
        "custodianAcctShort": "Custodian Acct #",
        "accountStatus": "Account Status",
        "transactionId": "Transaction ID",
        "subTransactionId": "Sub-Trans ID",
        "financialProductId": "Fin Product ID",
        "activityType": "Type",
        "activityStatus": "Status"
      },
      "internalNotesHeading": "Internal notes",
      "notesLabel": "Notes",
      "notesPlaceholder": "Add notes about your investigation…",
      "notesHistoryEmptyTitle": "No notes yet",
      "notesHistoryEmptyReadOnlyTitle": "No notes for this flag",
      "notesHistoryEmptyDescription": "Add a note to capture important context about this flag.",
      "addNote": "Add note",
      "notesSaved": "Notes saved",
      "notesSaveError": "Could not save notes",
      "discardDraftConfirmTitle": "Discard unsaved note?",
      "discardDraftConfirmBody": "You have a note that has not been saved. Close without saving?",
      "discardDraftConfirmAction": "Discard and close"
    },
    "bulkDismissError": "Could not dismiss selected flags",
    "bulkDismissSuccess": "{{count}} flags dismissed",
    "bulkDismissPartial": "{{failed}} of {{total}} flags could not be dismissed",
    "bulkDismissNoFlaggedSelected": "None of the selected flags can be dismissed. Only active flags can be dismissed from this view.",
    "emptyTable": "No flags match the current filters.",
    "emptyTableHint": "Try adjusting your filters or search.",
    "emptyTableNoResults": "No flags found.",
    "emptyTableNoData": "No data available.",
    "pagination": {
      "summary": "Showing {{start}}–{{end}} of {{total}} flags"
    }
  },
  "flagGlossary": {
    "title": "Flag Glossary",
    "openGlossary": "Glossary",
    "backToFlags": "Back to flags",
    "searchPlaceholder": "Search flags",
    "loadError": "Could not load flag glossary. Please try again.",
    "emptyTable": "No flags match the current filters.",
    "emptyTableHint": "Try adjusting your filters or search.",
    "emptyTableNoResults": "No flags found.",
    "emptyTableNoData": "No flag glossary data available.",
    "emptyTableError": "Couldn't load flags.",
    "emptyTableErrorHint": "Something went wrong. Please try again.",
    "filters": {
      "category": "Category",
      "clearFilters": "Clear filters"
    },
    "kpi": {
      "total": "Total flags available",
      "totalHint": "All flag types in the glossary",
      "thresholded": "Thresholded flags",
      "thresholdedHint": "Flags that support amount or percent thresholds",
      "turnedOff": "Turned off",
      "turnedOffHint": "Flag types disabled for this organization"
    },
    "table": {
      "flagName": "Flag name",
      "description": "Description",
      "exampleTrigger": "Example trigger",
      "category": "Category",
      "actualPriority": "Actual priority",
      "actualThreshold": "Actual threshold",
      "defaultPriority": "Default priority",
      "defaultThreshold": "Default threshold"
    },
    "pagination": {
      "summary": "Showing {{start}}–{{end}} of {{total}} flag types"
    },
    "entries": {
      "INVALID_BOOK_VALUE_AMOUNT": {
        "description": "A switch activity in the custodian file has valid quantity, price, and symbol, but the book value amount is invalid (e.g. switch-in requires book value > 0; switch-out requires book value < 0).",
        "exampleTrigger": "Switch-in for ABC has qty 10 and a price, but bookValueAmountCents is 0 or missing → “SWI listed in activity file, but book value amount is invalid.”"
      },
      "FEE_NOT_FOUND": {
        "description": "A fee activity appears in the custodian feed, but no matching fee withdrawal transfer was found on the platform (in REQUESTED state).",
        "exampleTrigger": "A $25 management fee appears in the custodian activity file for the account, but no corresponding fee transfer exists on the platform to reconcile against it."
      },
      "FEE_AMOUNT_DIFFERENT": {
        "description": "Custodian fee activity amount does not match the sum of platform REQUESTED fee withdrawal transfers (grouped by source). Flag-service may suppress below an org-configured dollar (cents) threshold.",
        "exampleTrigger": "Custodian fee is $125.00 and platform fee withdrawals sum to $100.00 → flag is raised unless the org threshold covers the $25.00 gap."
      },
      "TRADE_NOT_FOUND": {
        "description": "A trade appears in the custodian activity file, but no matching trade was found on the platform to reconcile against it.",
        "exampleTrigger": "Custodian activity shows a BUY of VOO, but there is no matching PROCESSING trade on the platform."
      },
      "ACCOUNT_NOT_FOUND": {
        "description": "An activity or record references an account number that does not exist in the system where it is expected to be found.",
        "exampleTrigger": "Custodian activity references an account number that is not registered on the platform."
      },
      "TRANSFER_NOT_FOUND": {
        "description": "A transfer-related activity appears in the custodian activity file (or an incoming settlement has no in-progress candidates), but no matching platform transfer was found.",
        "exampleTrigger": "Custodian posts an incoming settlement of $10,000 and the sub-account has no REQUESTED/PROCESSING external transfer candidates → flag is raised. (Other paths use the same “listed in activity file, but not found” pattern.)"
      },
      "UNKNOWN_ACTIVITY_TYPE": {
        "description": "An activity code or type reported by the custodian or system does not match any recognized activity type in the mapping configuration.",
        "exampleTrigger": "The custodian feed includes activity code \"XYZ\" with no corresponding mapping to a known activity type."
      },
      "FINANCIAL_PRODUCT_NOT_FOUND": {
        "description": "An activity or holding references a financial product (security, fund, etc.) that does not exist in the product catalog.",
        "exampleTrigger": "A trade references CUSIP 123456789, but no matching financial product record exists in the system."
      },
      "NOT_CORPORATE_ACCOUNT": {
        "description": "An activity type that is only expected on corporate accounts was found posted to a non-corporate account type.",
        "exampleTrigger": "A corporate action activity is posted to an individual taxable account instead of a corporate account."
      },
      "TOO_MANY_EXTERNAL_TRANSFER_IN_CANDIDATES_FOUND": {
        "description": "More than one custodian transfer record matches the details of a single expected incoming transfer, preventing automatic matching.",
        "exampleTrigger": "Three separate custodian transfers match the same deposit reference and amount, so the system cannot auto-resolve which one applies."
      },
      "CURRENCY_IS_NOT_AVAILABLE": {
        "description": "An activity references a currency that is not enabled or supported for the account's custodian connection.",
        "exampleTrigger": "A trade is denominated in a currency that has not been enabled for that custodian connection."
      },
      "NSF_REBOOKING_DETECTED": {
        "description": "An NSF activity is skipped because a custodian rebooking pattern was detected: a paired EFT/CXLEFT exists with the same absolute amount, account, parse date, and currency (often used when the custodian updates contributor codes).",
        "exampleTrigger": "NSF of −$500 and an EFT of +$500 post on the same account and parse date → NSF is skipped and this flag is raised."
      },
      "HBP_WITHDRAW_TRANSFER_NOT_FOUND": {
        "description": "An HBP withdrawal activity appears in the custodian activity file, but no matching platform USER withdraw in PROCESSING with reason Home Buyers’ Plan was found (expected on RRSP / RRSP spousal).",
        "exampleTrigger": "Custodian shows an HBP withdrawal of $35,000 on an RRSP, but the platform has no PROCESSING HBP withdraw for that amount to reconcile."
      },
      "EFT_ACTIVITY_NOT_FOUND": {
        "description": "An NSF activity references a subTransactionId that has no matching prior EFT or internal withdraw (WDL) activity in the custodian feed for that account and currency.",
        "exampleTrigger": "NSF of −$1,200 with subTransactionId=ABC-99 is received, but no EFT or WDL activity with that subTransactionId exists → flag is raised."
      },
      "TRANSFER_AMOUNT_DIFFERENT": {
        "description": "An incoming custodian settlement amount is outside ±10% of all candidate in-progress (REQUESTED/PROCESSING) external transfers on the sub-account, so automatic matching is blocked.",
        "exampleTrigger": "Settlement is $10,000 but the only in-progress candidate is $8,500 (15% off) → flag is raised for manual reconciliation."
      },
      "TRANSFER_IMPORT_FAILED": {
        "description": "A transfer row in the custodian transfer-import job file was classified as FAILED and was not successfully imported.",
        "exampleTrigger": "Import file marks transfer 64a1… as FAILED → flag message references that import file key."
      },
      "TRANSFER_STUCK_PROCESSING": {
        "description": "A USER-source transfer has remained in Processing longer than the SLA of 2 business days (based on the latest state change into Processing).",
        "exampleTrigger": "A USER withdraw moved to Processing on Monday and is still Processing on Wednesday (2 business days) → flag is raised."
      },
      "TRANSFER_STUCK_INITIATED": {
        "description": "A USER withdraw has remained in Initiated for the SLA window of 3 business days without progressing.",
        "exampleTrigger": "A USER withdraw entered Initiated exactly 3 business days ago and is still Initiated → flag is raised."
      },
      "TRANSFER_STUCK_READY": {
        "description": "A USER-source transfer has remained in Ready longer than the SLA of 3 business days, or custodian submission returned a fail reason that raises the same flag type.",
        "exampleTrigger": "A USER deposit has been Ready for 3+ business days without progressing → flag is raised."
      },
      "FAILED_ACCOUNT": {
        "description": "Account setup or provisioning failed at some point in the process and requires operational follow-up to resolve.",
        "exampleTrigger": "Account creation completed on the platform, but custodian onboarding returned a failure status."
      },
      "FAILED_CUSTODIAN_OPENING": {
        "description": "Custodian account opening (or, in some paths, transfer submission) returned a pending task list rather than completing successfully.",
        "exampleTrigger": "Account-opening webhook returns a pending task list → FAILED_CUSTODIAN_OPENING is published with message “Custodian account opening returned pending task list.”"
      },
      "FAILED_CUSTODIAN_ACCOUNT_OPENING": {
        "description": "Submitting the custodian account opening request failed hard (exception / unsuccessful open), so no confirmed custodian account was established.",
        "exampleTrigger": "submitCustodianAccountOpening fails with a connection timeout → flag “Custodian account opening failed.”"
      },
      "ACCOUNT_CLOSED": {
        "description": "The custodian EOD AccountInfo file marks the account as CLOSED (Status=CLOSED or ClosedDate set) while the platform account is still active (feature-gated).",
        "exampleTrigger": "Custodian account 12345678 is CLOSED in AccountInfo; the platform account is still ACTIVE → “Account 12345678 is marked as CLOSED by the custodian.”"
      },
      "TOTAL_MARKET_VALUE_INCORRECT": {
        "description": "Account market value dropped more than 15% (default) versus the previous day’s reconciliation snapshot. Increases are ignored.",
        "exampleTrigger": "Previous day OneVest MV was $100,000; current day is $80,000 (−20%) with default 15% threshold → flag is raised."
      },
      "STATEMENT_NOT_FOUND": {
        "description": "No account statement was found for the prior month for a custodian account that still has market value on the platform.",
        "exampleTrigger": "Account 98765432 has $12,500 market value but no statement for June 2026 → flag is raised."
      },
      "CASH_NOT_FOUND": {
        "description": "An expected cash balance or cash line item could not be located during reconciliation.",
        "exampleTrigger": "The custodian snapshot includes a cash balance, but the platform has no corresponding cash record for the account."
      },
      "HOLDING_NOT_FOUND": {
        "description": "The custodian reports a holding that does not exist in the platform's records for that account.",
        "exampleTrigger": "The custodian reports 200 shares of XYZ, but the platform shows no position for that symbol."
      },
      "HOLDING_NOT_FOUND_IN_CUSTODIAN": {
        "description": "A holding exists in the platform's records but was not found in the custodian's holdings for that account.",
        "exampleTrigger": "The platform shows 100 shares of ABC, but the custodian's holdings do not list that symbol."
      },
      "MONEY_AVAILABLE_VALUE_INCORRECT_V2": {
        "description": "After cash reconciliation, platform money available does not equal the custodian snapshot money available (same currency). Publishing may be suppressed only if an org configures a cents (or percent) threshold gate; there is no platform default threshold.",
        "exampleTrigger": "Platform money available is $999.00 and custodian snapshot shows $1,000.00 → flag is raised unless the org’s threshold absorbs the $1.00 difference."
      },
      "DIFFERENT_HOLDINGS_V2": {
        "description": "After holdings reconciliation, platform quantity for a symbol does not equal the custodian holding-file quantity. Publishing may be suppressed only if an org configures a percent threshold; there is no platform default percent.",
        "exampleTrigger": "Holding file shows 100 shares of XYZ and the platform shows 90 → flag is raised unless the org percent threshold allows that gap."
      },
      "NEGATIVE_CASH": {
        "description": "The cash balance in an account has fallen below zero.",
        "exampleTrigger": "An account's cash position is negative after a trade settles."
      },
      "NEGATIVE_HOLDING": {
        "description": "A security position shows a negative share or unit quantity.",
        "exampleTrigger": "The holdings quantity for a symbol is recorded as less than zero."
      },
      "PENDING_TRANSACTION_MONEY_AVAILABLE_VALUE_INCORRECT": {
        "description": "Same as Money Available V2, but the comparison uses money available adjusted for pending transactions.",
        "exampleTrigger": "After adjusting for pending trades, platform available is $5,000 but the custodian snapshot implies $5,200 → flag is raised (subject to org gate)."
      },
      "PENDING_TRANSACTION_DIFFERENT_HOLDINGS": {
        "description": "Same as Different Holdings V2, but quantities are adjusted for pending transactions before compare.",
        "exampleTrigger": "After pending sells, platform projects 50 shares of ABC but the custodian file still shows 60 → flag is raised (subject to org gate)."
      },
      "DIFFERENT_BOOKVALUE": {
        "description": "Book value on the custodian holding file differs from platform book value for a symbol (only when book-value flags are enabled). May be gated by an org cents threshold.",
        "exampleTrigger": "Holding file book value is $1,000 and platform book value is $1,050 for ABC → flag is raised when the feature is on."
      },
      "NO_SNAPSHOTS_RECEIVED": {
        "description": "No SubAccountDailyStats (history daily snapshots) were received for the expected date.",
        "exampleTrigger": "For 2026-07-21, history has zero daily stats rows → “No daily snapshots received for 2026-07-21.”"
      },
      "SNAPSHOT_MISSING": {
        "description": "A prior-day daily snapshot exists for a sub-account, but today’s SubAccountDailyStats row is missing.",
        "exampleTrigger": "Sub-account had stats yesterday, but none for 2026-07-21 → “Missing snapshot for subAccount {id} 2026-07-21.”"
      },
      "SNAPSHOT_ANOMALY": {
        "description": "Daily snapshot contribution fields are inconsistent: on the first snapshot, market value / net contribution / new contribution are pairwise unequal; otherwise newContributionCents does not equal the day-over-day change in net contribution.",
        "exampleTrigger": "Yesterday net contribution was $1,000 and today is $1,100, but newContributionCents is $50 (not $100) → flag is raised."
      },
      "SNAPSHOT_PRICE_NOT_FOUND": {
        "description": "A market price needed to value a position in a snapshot could not be located for that date.",
        "exampleTrigger": "A snapshot lists symbol XYZ, but no market price is available for the snapshot date."
      },
      "NOT_ENOUGH_MONEY_AVAILABLE_IN_ACCOUNT": {
        "description": "A withdraw-all cannot be processed because money available across the account (after summing negative available balances) is insufficient.",
        "exampleTrigger": "Withdraw-all targets $5,000 but other sub-accounts contribute −$6,000 available → “Withdraw all cannot be processed due to not having enough money available in an account.”"
      },
      "RISKY_DIFFERENT_HOLDING_MF_SELL_ALL": {
        "description": "For a mutual-fund sell-all trade, expected quantity vs custodian activity quantity differs by at least 10% (org must allow pending-transaction logic; flag-service default percent is 10%).",
        "exampleTrigger": "Sell-all expects quantity 100 but activity quantity is 85 (15% discrepancy) → flag is raised."
      },
      "RISKY_DIFFERENT_HOLDING_USD_ETF": {
        "description": "For a USD ETF trade, expected value vs activity value (quantity × price) differs by at least 10% (same gating as MF sell-all).",
        "exampleTrigger": "Trade allocated $10,000 but fill value is $8,500 (15% value discrepancy) → flag is raised."
      }
    }
  },
  "accountSnapshot": {
    "security": "Security",
    "systemQuantity": "System Quantity",
    "externalQuantity": "External Quantity",
    "diffQuantity": "Diff Quantity",
    "systemPrice": "System Price",
    "externalPrice": "External Price",
    "diffPrice": "Diff Price",
    "systemValue": "System Value",
    "externalValue": "External Value",
    "diffValue": "Diff Value",
    "systemBookValue": "System Book Value",
    "externalBookValue": "External Book Value",
    "diffBookValue": "Diff Book Value",
    "ledger": "Ledger",
    "transfers": "Transfers",
    "tradeOrders": "Trade Orders",
    "custodianActivities": "External Activities",
    "total": "Total"
  }
}
